import { POSTHOG_TRACKING_SOURCES } from '@terminal/services/tracking/posthog/constants';
import { usePosthogEvents } from '@terminal/services/tracking/posthog/use-posthog-events/usePosthogEvents';
import { CalendarReportingDates } from '@terminal/widgets/earnings/components/calendar-reporting-dates/CalendarReportingDates';

import { type CalendarQuarterPeriod } from './utils';

export interface ThemeEarningsReportingDatesProps {
  reportingPeriods: CalendarQuarterPeriod[];
  activeReportingPeriod?: CalendarQuarterPeriod;
  onActiveReportingPeriodChange: (
    reportingPeriod: CalendarQuarterPeriod
  ) => void;
}

export const ThemeEarningsReportingDates = ({
  reportingPeriods,
  activeReportingPeriod,
  onActiveReportingPeriodChange,
}: ThemeEarningsReportingDatesProps) => {
  const { trackThemeEarningsPeriodSelected } = usePosthogEvents();

  if (!activeReportingPeriod) {
    return null;
  }

  return (
    <CalendarReportingDates
      reportingPeriods={reportingPeriods}
      activeReportingPeriod={activeReportingPeriod}
      onActiveReportingPeriodChange={period => {
        trackThemeEarningsPeriodSelected(
          POSTHOG_TRACKING_SOURCES.THEME_OVERVIEW,
          `${period.quarter} ${period.year}`
        );
        onActiveReportingPeriodChange(period);
      }}
    />
  );
};
